import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { useDispatch, useSelector } from 'react-redux';
import { attendanceTypes, recordTypes, specialties } from '../../../store/reducers/dicts';
import { MenuItem, Box, Stack, IconButton } from '@mui/material';
import _ from 'lodash';
import Grid from '@mui/material/Grid';
import AgyleDatePicker from '../../ui/fields/agyleDatePicker';
import AgyleSelectField from '../../ui/selector/agyleSelectField';
import { AutocompleteDictionary } from '../../../controls/agyle/autocomplete';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { loadUploadDicts } from '../../../store/reducers/dicts';
import { hasPermission } from '../../../store/reducers/user';
import { useTranslation } from 'react-i18next';
import { INIT_DOC_UPLOAD_DATA } from '../store/constans';
import CircularProgress from '@mui/material/CircularProgress';
import { isMoment } from 'moment';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    loadingBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '20px',
        padding: '10px',
        width: '100%',
    },
    '.file-upload-item-form': {
        width: 'calc(100% - 200px)',
        display: 'block',
        flexGrow: '1 1 auto',
    },
}));

export default function UploadForm(props) {
    const [fileData, setFileData] = React.useState(null); //should be from props?
    const { t } = useTranslation();
    const classes = useStyles();
    const dispatch = useDispatch();
    const config = window.envConfig.documentViewer.uploadFields;
    const [loadedDicts, setLoadedDicts] = React.useState(false);
    const [accessRoleItems, setAccessRoleItems] = React.useState([]);
    const [defaultAccessRole, setDefaultAccessRole] = React.useState(null);
    const specialtiesDict = useSelector(specialties);
    const [defaultSpecialties, setDefaultSpecialties] = React.useState(null);
    const recordTypesDict = useSelector(recordTypes);
    const [defaultRecordType, setDefaultRecordType] = React.useState(null);
    const [storages, setStorages] = React.useState([]);
    const [defaultStorage, setDefaultStorage] = React.useState(null);
    const [allCatalogAttendances, setAllCatalogAttendances] = React.useState([]);
    const [allCatalogReferrals, setAllCatalogReferrals] = React.useState([]);
    const [allTasks, setAllTasks] = React.useState([]);
    const dictAttendanceTypes = useSelector(attendanceTypes);
    const [dictsAttendancesReady, setAttendancesDictsReady] = React.useState(false);
    const [dictsReferralsReady, setReferralsDictsReady] = React.useState(false);
    const [validationStep, setValidationStep] = React.useState(0);
    const [errorSet, setErrorSet] = React.useState({});

    React.useEffect(() => {
        dispatch(loadUploadDicts);
        let accessRoles = [];
        _.get(config, 'accessRole.documentUploadAccessKeyCloakRoles', []).forEach((role) => {
            if (hasPermission(role.role)) {
                accessRoles.push(role);
                if (role.default) {
                    setDefaultAccessRole(role);
                }
            }
        });
        setAccessRoleItems(accessRoles);
        let storages = _.get(config, 'storage.uploadSources', []);
        setStorages(storages);
        if (storages.length == 1) {
            setDefaultStorage(storages[0]);
        } else {
            setDefaultStorage(_.find(storages, (s) => s.default));
        }
    }, []);

    React.useEffect(() => {
        if (props.attendances) {
            let attendancesTmp = [];
            props.attendances.forEach((attendance) => {
                let attendanceTmp = {
                    id: attendance.id,
                    spell: '',
                    attendanceNo: _.get(attendance, 'metadata.episodeNumber', ''),
                    attendanceTypeId: _.get(attendance, 'metadata.attendanceTypeId', ''),
                    attendanceType: '',
                };
                let dictAttendanceTypeItem = _.find(dictAttendanceTypes, (type) => type.__code === attendanceTmp.attendanceTypeId);
                attendanceTmp.attendanceType = dictAttendanceTypeItem ? dictAttendanceTypeItem.__description : '';
                attendancesTmp.push(attendanceTmp);
            });
            setAllCatalogAttendances(attendancesTmp);
            setAttendancesDictsReady(true);
        } else {
            setAttendancesDictsReady(false);
        }
        if (props.referrals) {
            let referralsTmp = [];
            props.referrals.forEach((referral) => {
                let referralTmp = {
                    id: referral.id,
                    spell: '',
                    referralNo: _.get(referral, 'metadata.episodeNumber', ''),
                    referralTypeId: _.get(referral, 'metadata.attendanceTypeId', ''),
                    referralType: '',
                };
                let dictAttendanceTypeItem = _.find(dictAttendanceTypes, (type) => type.__code === referralTmp.referralTypeId);
                referralTmp.attendanceType = dictAttendanceTypeItem ? dictAttendanceTypeItem.__description : '';
                referralsTmp.push(referralTmp);
            });
            setAllCatalogReferrals(referralsTmp);
            setReferralsDictsReady(true);
        } else {
            setReferralsDictsReady(false);
        }
    }, [props.attendances, props.referrals, dictAttendanceTypes]);

    React.useEffect(() => {
        const loaded = specialtiesDict && recordTypesDict;
        setLoadedDicts(loaded);
        if (loaded) {
            if (specialtiesDict.length == 1) {
                setDefaultSpecialties(specialtiesDict[0]);
            }
            if (recordTypesDict.length == 1) {
                setDefaultRecordType(recordTypesDict[0]);
            }
        }
    }, [specialtiesDict, recordTypesDict]);

    React.useEffect(() => {
        if (loadedDicts) {
            if (props.fileData != null) {
                setFileData(props.fileData);
            } else {
                setFileData(buildEmptyFileData());
            }
        }
    }, [props.fileData, loadedDicts]);

    React.useEffect(() => {
        if (props.uploadValidate && props.uploadValidate > 0 && props.uploadValidate > validationStep) {
            props.onValidate(validateForm(props.formId));
            setValidationStep(props.uploadValidate);
        }
    }, [props.uploadValidate]);

    const buildEmptyFileData = () => {
        let data = { ...INIT_DOC_UPLOAD_DATA };
        if (defaultAccessRole) {
            data.accessRole = defaultAccessRole;
            data.accessRoleValue = defaultAccessRole.role;
        }
        if (defaultStorage) {
            data.storage = defaultStorage;
            data.storageValue = defaultStorage.code;
        }
        if (defaultRecordType) {
            data.recordType = defaultRecordType;
            data.recordTypeValue = _.get(defaultRecordType, '__id', '');
        }
        if (defaultSpecialties) {
            data.docClass = defaultSpecialties;
            data.docClassValue = _.get(defaultSpecialties, '__id', '');
        }
        return data;
    };

    const setDataToUploadForm = (propertyName, value, idx = -1) => {
        let fileDataTmp = _.cloneDeep(fileData);
        if (value !== null) clearErrorSetField(propertyName);
        switch (propertyName) {
            case 'docDate': {
                fileDataTmp.docDate = value;
                break;
            }
            case 'docTime': {
                fileDataTmp.docTime = value;
                break;
            }
            case 'docType': {
                fileDataTmp.docType = value;
                fileDataTmp.docTypeValue = _.get(value, '__id', '');
                break;
            }
            case 'docClass': {
                fileDataTmp.docClass = value;
                fileDataTmp.docClassValue = _.get(value, '__id', '');
                break;
            }
            case 'recordType': {
                fileDataTmp.recordType = value;
                fileDataTmp.recordTypeValue = _.get(value, '__id', '');
                break;
            }
            case 'accessRole': {
                fileDataTmp.accessRole = value;
                fileDataTmp.accessRoleValue = _.get(value, 'role', '');
                break;
            }
            case 'storage': {
                fileDataTmp.storage = value;
                fileDataTmp.storageValue = _.get(value, 'code', '');
                break;
            }
            case 'attendance': {
                fileDataTmp.attendanceIds[idx] = _.get(value, 'id', '');
                break;
            }
            case 'taskId': {
                fileDataTmp.storage = value;
                fileDataTmp.storageValue = _.get(value, 'id', '');
                break;
            }
            case 'altAttendance': {
                fileDataTmp.alternativeAttendanceId = _.get(value, 'id', '');
                break;
            }
            case 'referral': {
                fileDataTmp.referralIds[idx] = _.get(value, 'id', '');
                break;
            }
        }
        props.onChange(fileDataTmp);
    };

    const clearErrorSetField = (propertyName) => {
        let errorSetTmp = _.cloneDeep(errorSet);
        switch (propertyName) {
            case 'docDate': {
                delete errorSetTmp.docDate;
                delete errorSetTmp.docDateBool;
                break;
            }
            case 'docTime': {
                delete errorSetTmp.docTime;
                delete errorSetTmp.docTimeBool;
                break;
            }
            case 'docType': {
                delete errorSetTmp.docType;
                delete errorSetTmp.docTypeBool;
                break;
            }
            case 'docClass': {
                delete errorSetTmp.docClass;
                delete errorSetTmp.docClassBool;
                break;
            }
            case 'recordType': {
                delete errorSetTmp.recordType;
                delete errorSetTmp.recordTypeBool;
                break;
            }
            case 'accessRole': {
                delete errorSetTmp.accessRole;
                delete errorSetTmp.accessRoleBool;
                break;
            }
            case 'storage': {
                delete errorSetTmp.storage;
                delete errorSetTmp.storageBool;
                break;
            }
            case 'attendance': {
                delete errorSetTmp.attendanceIds;
                delete errorSetTmp.attendanceIdsBool;
                break;
            }
            case 'taskId': {
                delete errorSetTmp.taskId;
                delete errorSetTmp.taskIdBool;
                break;
            }
            case 'altAttendance': {
                delete errorSetTmp.altAttendance;
                delete errorSetTmp.altAttendanceBool;
                break;
            }
            case 'referral': {
                delete errorSetTmp.referralIds;
                delete errorSetTmp.referralIdsBool;
                break;
            }
        }
        setErrorSet(errorSetTmp);
    };

    const getDocTypeDictionaryURL = (filter) => {
        let newFilter = '(deactivated ne true and isEReferral ne true)';

        if (filter !== '') {
            newFilter = `(${filter} and deactivated ne true and isEReferral ne true)`;
        }

        return `/DocTypes?$expand=tab&$filter=${encodeURIComponent(newFilter)}&$sort=name`;
    };

    const validateForm = (formId) => {
        let valid = true;
        let errors = {};
        if (_.get(config, 'docDate.required', false) && !fileData.docDate) {
            errors.docDate = t('Please select a date');
            errors.docDateBool = true;
            valid = false;
        }
        if (_.get(config, 'docTime.required', false) && !fileData.docTime) {
            errors.docTime = t('Please select a time');
            errors.docTimeBool = true;
            valid = false;
        }
        if (_.get(config, 'docType.required', false) && !fileData.docType) {
            errors.docType = t('Please select a document type');
            errors.docTypeBool = true;
            valid = false;
        }
        if (_.get(config, 'docClass.required', false) && !fileData.docClass) {
            errors.docClass = t('Please select a document class');
            errors.docClassBool = true;
            valid = false;
        }
        if (_.get(config, 'recordType.required', false) && !fileData.recordType) {
            errors.recordType = t('Please select a record type');
            errors.recordTypeBool = true;
            valid = false;
        }
        if (_.get(config, 'accessRole.required', false) && !fileData.accessRole) {
            errors.accessRole = t('Please select a access role');
            errors.accessRoleBool = true;
            valid = false;
        }
        if (_.get(config, 'storage.required', false) && !fileData.storage) {
            errors.storage = t('Please select a storage');
            errors.storageBool = true;
            valid = false;
        }
        if (_.get(config, 'attendance.required', false) && fileData.attendanceIds.length > 0 && fileData.attendanceIds[0].length === 0) {
            errors.attendanceIds = t('Please select attendance ID');
            errors.attendanceIdsBool = true;
            valid = false;
        }
        if (_.get(config, 'taskId.required', false) && !fileData.taskId) {
            errors.taskId = t('Please select a task ID');
            errors.taskIdBool = true;
            valid = false;
        }
        if (_.get(config, 'altAttendance.required', false) && !fileData.alternativeAttendanceId) {
            errors.altAttendance = t('Please select alternative attendance ID');
            errors.altAttendanceBool = true;
            valid = false;
        }
        if (_.get(config, 'referral.required', false) && !fileData.referralIds.length > 0 && fileData.referralIds[0].length === 0) {
            errors.referralIds = t('Please select a referral ID');
            errors.referralIdsBool = true;
            valid = false;
        }
        setErrorSet(!valid ? errors : {});
        return { form: formId, valid: valid, errors: errors };
    };

    return (
        <div className={classes.root}>
            {fileData && (
                <div className="file-upload-item-form">
                    <Grid container spacing={2} className="grid-container">
                        {_.get(config, 'docDate.visible', true) && (
                            <Grid item md={6}>
                                <AgyleDatePicker
                                    onChange={(date) => {
                                        setDataToUploadForm('docDate', date);
                                    }}
                                    value={fileData.docDate}
                                    type="date"
                                    size="small"
                                    noBorder={false}
                                    error={errorSet.docDateBool}
                                />
                            </Grid>
                        )}
                        {_.get(config, 'docTime.visible', true) && (
                            <Grid item md={6}>
                                <AgyleDatePicker
                                    onChange={(time) => {
                                        setDataToUploadForm('docTime', time);
                                    }}
                                    value={fileData.docTime}
                                    type="time"
                                    ampm={false}
                                    openTo="minutes"
                                    views={['hours', 'minutes']}
                                    inputFormat="HH:mm"
                                    mask="__:__"
                                    disabled={props.disabled || props.isBooked}
                                    size="small"
                                    noBorder={false}
                                    error={errorSet.docTimeBool}
                                />
                            </Grid>
                        )}
                        {_.get(config, 'docType.visible', true) && (
                            <Grid item md={12}>
                                <Box>{t('Doc type')}</Box>
                                <AutocompleteDictionary
                                    groupBy={(opt) => {
                                        return _.get(opt, 'tab.name', '');
                                    }}
                                    dictionaryURL={getDocTypeDictionaryURL}
                                    dontTrimSearch
                                    onChange={(docTypeSelected) => {
                                        setDataToUploadForm('docType', docTypeSelected);
                                    }}
                                    noBorder={false}
                                    getOptionLabel={(option) => {
                                        return option.name || '';
                                    }}
                                    searchColumnName={'name'}
                                    renderText={'name'}
                                    withNewBackground={false}
                                    value={fileData.docType}
                                    error={errorSet.docTypeBool}
                                />
                            </Grid>
                        )}
                        {_.get(config, 'docClass.visible', true) && (
                            <Grid item md={6}>
                                <Box>{t('Doc Class')}</Box>
                                <AgyleSelectField
                                    style={{
                                        height: '100%',
                                        minHeight: '36px',
                                    }}
                                    onChange={(docClass) => {
                                        if (docClass) {
                                            const item = _.find(specialtiesDict, (spec) => spec.__id === docClass, undefined);
                                            setDataToUploadForm('docClass', item);
                                        } else {
                                            setDataToUploadForm('docClass', null);
                                        }
                                    }}
                                    withBackground
                                    withBorder
                                    defaultClearValue={''}
                                    options={specialtiesDict}
                                    value={fileData.docClassValue}
                                    customObject={(opt) => {
                                        return (
                                            <MenuItem key={`doc_class_opt-${opt.__id}`} value={opt.__id}>
                                                {opt.__description}
                                            </MenuItem>
                                        );
                                    }}
                                    error={errorSet.docClassBool}
                                ></AgyleSelectField>
                            </Grid>
                        )}
                        {_.get(config, 'recordType.visible', true) && (
                            <Grid item md={6}>
                                <Box>{t('Record Type')}</Box>
                                <AgyleSelectField
                                    style={{
                                        height: '100%',
                                        minHeight: '36px',
                                    }}
                                    onChange={(recordType) => {
                                        if (recordType) {
                                            const item = _.find(recordTypesDict, (spec) => spec.__id === recordType, undefined);
                                            setDataToUploadForm('recordType', item);
                                        } else {
                                            setDataToUploadForm('recordType', null);
                                        }
                                    }}
                                    withBackground
                                    withBorder
                                    defaultClearValue={''}
                                    options={recordTypesDict}
                                    value={fileData.recordTypeValue}
                                    customObject={(opt) => {
                                        return (
                                            <MenuItem key={`rec_type_opt-${opt.__id}`} value={opt.__id}>
                                                {opt.__description}
                                            </MenuItem>
                                        );
                                    }}
                                    error={errorSet.recordTypeBool}
                                ></AgyleSelectField>
                            </Grid>
                        )}
                        {_.get(config, 'accessRole.visible', true) && (
                            <Grid item md={6}>
                                <Box>{t('Access Role')}</Box>
                                <AgyleSelectField
                                    style={{
                                        height: '100%',
                                        minHeight: '36px',
                                    }}
                                    onChange={(accessRole) => {
                                        if (accessRole) {
                                            const item = _.find(accessRoleItems, (role) => role.role === accessRole, undefined);
                                            setDataToUploadForm('accessRole', item);
                                        } else {
                                            setDataToUploadForm('accessRole', null);
                                        }
                                    }}
                                    withBackground
                                    withBorder
                                    defaultClearValue={''}
                                    options={accessRoleItems}
                                    value={fileData.accessRoleValue}
                                    customObject={(opt) => {
                                        return (
                                            <MenuItem key={`access_role_opt-${opt.role}`} value={opt.role}>
                                                {opt.role}
                                            </MenuItem>
                                        );
                                    }}
                                    error={errorSet.accessRoleBool}
                                ></AgyleSelectField>
                            </Grid>
                        )}
                        {_.get(config, 'storage.visible', true) && (
                            <Grid item md={6}>
                                <Box>{t('Select Storage')}</Box>
                                <AgyleSelectField
                                    style={{
                                        height: '100%',
                                        minHeight: '36px',
                                    }}
                                    onChange={(storageValue) => {
                                        if (storageValue) {
                                            const item = _.find(storages, (storage) => storage.code === storageValue, undefined);
                                            setDataToUploadForm('storage', item);
                                        } else {
                                            setDataToUploadForm('storage', null);
                                        }
                                    }}
                                    withBackground
                                    withBorder
                                    defaultClearValue={''}
                                    options={storages}
                                    value={fileData.storageValue}
                                    customObject={(opt) => {
                                        return (
                                            <MenuItem key={`storage_opt-${opt.code}`} value={opt.code}>
                                                {opt.name}
                                            </MenuItem>
                                        );
                                    }}
                                    error={errorSet.storageBool}
                                ></AgyleSelectField>
                            </Grid>
                        )}
                        {_.get(config, 'attendance.visible', true) && (
                            <Grid item md={12}>
                                <Box>{t('Attendance ID')}</Box>
                                <Grid container>
                                    {fileData.attendanceIds &&
                                        fileData.attendanceIds.map((attnId, index) => {
                                            return (
                                                <Grid item md={6} key={`attendance-field-upload-${index}`}>
                                                    <Stack direction={'row'} spacing={1} justifyContent={'center'} alignItems={'center'}>
                                                        <AgyleSelectField
                                                            style={{
                                                                height: '100%',
                                                                minHeight: '36px',
                                                            }}
                                                            onChange={(attendanceId) => {
                                                                if (attendanceId) {
                                                                    const item = _.find(
                                                                        allCatalogAttendances,
                                                                        (attn) => attn.id === attendanceId,
                                                                        undefined,
                                                                    );
                                                                    setDataToUploadForm('attendance', item, index);
                                                                } else {
                                                                    setDataToUploadForm('attendance', null, index);
                                                                }
                                                            }}
                                                            withBackground
                                                            withBorder
                                                            disabled={!dictsAttendancesReady}
                                                            defaultClearValue={''}
                                                            options={allCatalogAttendances}
                                                            value={attnId}
                                                            customObject={(opt) => {
                                                                return (
                                                                    <MenuItem
                                                                        key={`attendance_opt-${index}-${opt.id}`}
                                                                        value={opt.id}
                                                                        disabled={
                                                                            _.findIndex(fileData.attendanceIds, (a) => a === opt.id) > -1 ||
                                                                            fileData.alternativeAttendanceId === opt.id
                                                                        }
                                                                    >
                                                                        <b>{opt.attendanceNo}</b>
                                                                        {`  (${opt.attendanceTypeId}) ${opt.attendanceType}`}
                                                                    </MenuItem>
                                                                );
                                                            }}
                                                            error={errorSet.attendanceIdsBool && index === 0}
                                                        ></AgyleSelectField>
                                                        {index > 0 && (
                                                            <IconButton
                                                                aria-label="Remove field"
                                                                onClick={() => {
                                                                    setFileData((prev) => {
                                                                        let tmp = _.cloneDeep(prev);
                                                                        tmp.attendanceIds.splice(index, 1);
                                                                        return tmp;
                                                                    });
                                                                }}
                                                            >
                                                                <DeleteIcon width={18} height={18} />
                                                            </IconButton>
                                                        )}
                                                        {index === 0 && (
                                                            <IconButton
                                                                disabled={!dictsAttendancesReady}
                                                                aria-label="Add more field"
                                                                onClick={() => {
                                                                    setFileData((prev) => {
                                                                        let tmp = _.cloneDeep(prev);
                                                                        tmp.attendanceIds.push('');
                                                                        return tmp;
                                                                    });
                                                                }}
                                                            >
                                                                <AddIcon width={18} height={18} />
                                                            </IconButton>
                                                        )}
                                                    </Stack>
                                                </Grid>
                                            );
                                        })}
                                </Grid>
                            </Grid>
                        )}
                        {_.get(config, 'taskId.visible', true) && (
                            <Grid item md={6}>
                                <Box>{t('Task ID')}</Box>
                                <AgyleSelectField
                                    style={{
                                        height: '100%',
                                        minHeight: '36px',
                                    }}
                                    onChange={(taskID) => {
                                        if (taskID) {
                                            const item = _.find(allTasks, (attn) => attn.id === taskID, undefined);
                                            setDataToUploadForm('taskId', item);
                                        } else {
                                            setDataToUploadForm('taskId', null);
                                        }
                                    }}
                                    withBackground
                                    withBorder
                                    disabled={true}
                                    defaultClearValue={''}
                                    options={allTasks}
                                    value={fileData.taskValue}
                                    error={errorSet.taskIdBool}
                                ></AgyleSelectField>
                            </Grid>
                        )}
                        {_.get(config, 'altAttendance.visible', true) && (
                            <Grid item md={6}>
                                <Box>{t('Alternative Attendance ID')}</Box>
                                <AgyleSelectField
                                    style={{
                                        height: '100%',
                                        minHeight: '36px',
                                    }}
                                    onChange={(altAttendanceId) => {
                                        if (altAttendanceId) {
                                            const item = _.find(allCatalogAttendances, (attn) => attn.id === altAttendanceId, undefined);
                                            setDataToUploadForm('altAttendance', item);
                                        } else {
                                            setDataToUploadForm('altAttendance', null);
                                        }
                                    }}
                                    withBackground
                                    withBorder
                                    disabled={!dictsAttendancesReady}
                                    defaultClearValue={''}
                                    options={allCatalogAttendances}
                                    value={fileData.alternativeAttendanceId}
                                    customObject={(opt) => {
                                        return (
                                            <MenuItem
                                                key={`attendance_opt-${props.index}-${opt.id}`}
                                                value={opt.id}
                                                disabled={
                                                    _.findIndex(fileData.attendanceIds, (a) => a === opt.id) > -1 ||
                                                    fileData.alternativeAttendanceId === opt.id
                                                }
                                            >
                                                <b>{opt.attendanceNo}</b>
                                                {`  (${opt.attendanceTypeId}) ${opt.attendanceType}`}
                                            </MenuItem>
                                        );
                                    }}
                                    error={errorSet.altAttendanceBool}
                                ></AgyleSelectField>
                            </Grid>
                        )}
                        {_.get(config, 'referral.visible', true) && (
                            <Grid item md={12}>
                                <Box>{t('Referral ID')}</Box>
                                <Grid container>
                                    {fileData.referralIds &&
                                        fileData.referralIds.map((refrrId, index) => {
                                            return (
                                                <Grid item md={6} key={`referral-field-upload-${index}`}>
                                                    <Stack direction={'row'} spacing={1} justifyContent={'center'} alignItems={'center'}>
                                                        <AgyleSelectField
                                                            style={{
                                                                height: '100%',
                                                                minHeight: '36px',
                                                            }}
                                                            onChange={(referralId) => {
                                                                if (referralId) {
                                                                    const item = _.find(
                                                                        allCatalogReferrals,
                                                                        (attn) => attn.id === referralId,
                                                                        undefined,
                                                                    );
                                                                    setDataToUploadForm('referral', item, index);
                                                                } else {
                                                                    setDataToUploadForm('referral', null, index);
                                                                }
                                                            }}
                                                            withBackground
                                                            withBorder
                                                            disabled={!dictsReferralsReady}
                                                            defaultClearValue={''}
                                                            options={allCatalogReferrals}
                                                            value={refrrId}
                                                            customObject={(opt) => {
                                                                return (
                                                                    <MenuItem
                                                                        key={`referral_opt-${index}-${opt.id}`}
                                                                        value={opt.id}
                                                                        disabled={
                                                                            _.findIndex(fileData.referralIds, (a) => a === opt.id) > -1
                                                                        }
                                                                    >
                                                                        <b>{opt.name || 'referralName'}</b>
                                                                        {`  (${opt.referralCode})`}
                                                                    </MenuItem>
                                                                );
                                                            }}
                                                            error={errorSet.referralIdsBool && index === 0}
                                                        ></AgyleSelectField>
                                                        {index > 0 && (
                                                            <IconButton
                                                                aria-label="Remove field"
                                                                onClick={() => {
                                                                    setFileData((prev) => {
                                                                        let tmp = _.cloneDeep(prev);
                                                                        tmp.referralIds.splice(index, 1);
                                                                        return tmp;
                                                                    });
                                                                }}
                                                            >
                                                                <DeleteIcon width={18} height={18} />
                                                            </IconButton>
                                                        )}
                                                        {index === 0 && (
                                                            <IconButton
                                                                disabled={!dictsReferralsReady}
                                                                aria-label="Add more field"
                                                                onClick={() => {
                                                                    setFileData((prev) => {
                                                                        let tmp = _.cloneDeep(prev);
                                                                        tmp.referralIds.push('');
                                                                        return tmp;
                                                                    });
                                                                }}
                                                            >
                                                                <AddIcon width={18} height={18} />
                                                            </IconButton>
                                                        )}
                                                    </Stack>
                                                </Grid>
                                            );
                                        })}
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                </div>
            )}
            {(!loadedDicts || fileData == null) && (
                <Box className={classes.loadingBox}>
                    {t('Loading dictionaries...')}
                    <CircularProgress color="inherit" size={64} />
                </Box>
            )}
        </div>
    );
}

export const UploadForm_PrepreUploadMetadata = (formData, catalog) => {
    const config = window.envConfig.documentViewer.uploadFields;
    let docDate = _.get(formData, 'docDate', null);
    let docTime = _.get(formData, 'docTime', null);
    let docDateTime = '';
    if (docDate != null && isMoment(docDate)) {
        docDateTime += docDate.format('YYYY-MM-DD');
    }
    if (docTime != null && isMoment(docTime)) {
        docDateTime += docTime.format(' hh:mm:ss');
    }
    let result = {
        path: `/${catalog}`,
        date: docDateTime,
        metadata: {},
    };
    if (_.get(config, 'docDate.visible', false)) {
        _.set(result, 'metadata.docType', _.get(formData, 'docTypeValue', ''));
        _.set(result, 'metadata.docTypeName', _.get(formData, 'docType.name', ''));
    }
    if (_.get(config, 'docClass.visible', false)) {
        _.set(result, 'metadata.docClass', _.get(formData, 'docClassValue', ''));
    }
    if (_.get(config, 'recordType.visible', false)) {
        _.set(result, 'metadata.recordType', _.get(formData, 'recordTypeValue', ''));
    }
    if (_.get(config, 'accessRole.visible', false)) {
        _.set(result, 'metadata.accessRole', _.get(formData, 'accessRoleValue', ''));
    }
    if (_.get(config, 'storage.visible', false)) {
        _.set(result, 'metadata.storage', _.get(formData, 'storageValue', ''));
    }
    if (_.get(config, 'attendance.visible', false)) {
        _.set(result, 'metadata.attendanceIds', _.get(formData, 'attendanceIds', ''));
    }
    if (_.get(config, 'taskId.visible', false)) {
        _.set(result, 'metadata.task', _.get(formData, 'taskValue', ''));
    }
    if (_.get(config, 'altAttendance.visible', false)) {
        _.set(result, 'metadata.altAttendanceId', _.get(formData, 'alternativeAttendanceId', ''));
    }
    if (_.get(config, 'referral.visible', false)) {
        _.set(result, 'metadata.referralIds', _.get(formData, 'referralIds', ''));
    }
    return JSON.stringify(result);
};
